import React from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import { FormCheckboxFieldProps, FormGroupFieldProps } from '../types';
import { useChange } from '../hooks';
import Group from '../GroupCheckbox';

type Props = {
  isRequired?: boolean;
  isKiosk?: boolean;
  value?: boolean;
};

const Checkbox: React.FC<Props & FormGroupFieldProps & FormCheckboxFieldProps> = ({
  isRequired = false,
  custom,
  label,
  ...props
}) => {
  const [{ name, value, onBlur }, { error, touched }] = useField(props);
  const handleChange = useChange(props);
  const isInvalid = Boolean(error) && touched;

  const isChecked = props.isKiosk ? !!props.value : !!value;

  return (
    <Group
      name={name}
      label={label}
      error={error}
      isRequired={isRequired}
      isInvalid={isInvalid}
      className={props.className}
    >
      <Form.Check.Input
        {...props}
        type="checkbox"
        checked={isChecked}
        isInvalid={isInvalid}
        onChange={handleChange}
        onBlur={onBlur}
      />
    </Group>
  );
};

export default Checkbox;
